import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { SchoolsService } from '../services/schools.service';

/**
 * Guard to handle school selection from dropdown
 * Extracts programPartnerId from route, updates current school, and redirects to mypage
 */
export const selectSchoolGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const schoolsService = inject(SchoolsService);
  const router = inject(Router);
  
  const programPartnerId = route.paramMap.get('programPartnerId');
  
  if (programPartnerId) {
    schoolsService.setCurrentSchool(programPartnerId);
  }
  
  // Redirect to mypage after setting the school
  router.navigate(['mypage']);
  
  // Return false to prevent activating the select-school route itself
  return false;
};
